<template>
  <container-component class="cc-consul">
    <div class="h1">
      Clocks Calendar
    </div>
    <iframe src="https://calendar.google.com/calendar/embed?height=600&amp;wkst=2&amp;bgcolor=%23ffffff&amp;ctz=America%2FLos_Angeles&amp;src=Y18xNGZxdWgxaTRyZGMzM3QzdWlwbDQ5MDFxb0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t&amp;color=%23616161&amp;mode=WEEK&amp;showTitle=0&amp;title=Clocks%20Meeting%20Cal&amp;showPrint=0&amp;showDate=1&amp;showCalendars=0" style="border-width:0" width="800" height="600" frameborder="0" scrolling="no"></iframe>
  </container-component>
</template>

<script>
import ContainerComponent from "@/components/ContainerComponent.vue";

  export default {
    name: 'Calendar',
    components: {
      ContainerComponent,
    }
  }
</script>

<style lang="scss" scoped>
.cc-consul {
  font-family: 'Space Grotesk';
  font-size: 64px;
  font-weight: 400;
  margin-bottom: 32px;
}
</style>